import type { SelectOption } from '../components/Component/types'

export const isAllValue = (value: string | number): boolean => {
  const lower = String(value).toLowerCase()
  return lower === 'all' || lower === 'todos'
}

export function normalizeAllExclusive(
  selected: string | number | (string | number)[],
  options: SelectOption[],
  previousValue: (string | number)[] = []
): (string | number)[] {
  const selectedArray = Array.isArray(selected) ? selected : selected ? [selected] : []
  const allOption = options.find((opt) => isAllValue(opt.value))
  if (!allOption) return selectedArray

  const hasAll = selectedArray.some((v) => isAllValue(v))
  const hasOthers = selectedArray.some((v) => !isAllValue(v))
  const previouslyHadAll = previousValue.some((v) => isAllValue(v))

  if (hasAll && hasOthers) {
    return previouslyHadAll
      ? selectedArray.filter((v) => !isAllValue(v))
      : [allOption.value]
  }
  if (hasAll) return [allOption.value]
  return selectedArray.filter((v) => !isAllValue(v))
}
